/*
    Autogenerated class model from django EnergyVector
    -- 2020-02-10 10:50:39.384890
*/
import Vue from 'vue';

// BaseObjectClass defines methods load, save, delete
import { BaseObjectClass, BaseCollection, BaseStoreCollection } from '@/base_object_class';
import { loadThenStoreByIdentifier } from './_helpers';

class EnergyVectorClass extends BaseObjectClass {
    constructor(rawData = {}) {
        super();
        this.populate(rawData);
    }

    populate(rawData = {}) {
        Vue.set(this, 'isLoading', false);
        Vue.set(this, 'pk', rawData.pk || null);
        Vue.set(this, 'id', rawData.pk || null);
        Vue.set(this, 'createdAt', new Date(rawData.createdAt));
        Vue.set(this, 'updatedAt', new Date(rawData.updatedAt));

        /* Define default values here if needed */
        Vue.set(this, 'vector', rawData.vector);
        Vue.set(this, 'buyingUnit', rawData.buyingUnit);
        Vue.set(this, 'pci', rawData.pci);
        Vue.set(this, 'unit', rawData.unit);
        Vue.set(this, 'energy', rawData.energy);
        Vue.set(this, 'order', rawData.order);
    }

    getBaseUrl() {
        return '/energies/energy-vector/';
    }

    get isValid() {
        return true;
    }
}

class EnergyVectorCollection extends BaseCollection {
    initModel(rawData) {
        return new EnergyVectorClass(rawData);
    }

    getBaseUrl() {
        return '/energies/energy-vector/';
    }
}

class EnergyVectorStoreCollection extends BaseStoreCollection {
    initModel(rawData) {
        return new EnergyVectorClass(rawData);
    }

    getBaseUrl() {
        return '/energies/energy-vector/';
    }

    getStorePath() {
        return 'energies/energyVectorCollection';
    }

    load(filter = null) {
        return loadThenStoreByIdentifier(this, super.load, 'vector', filter);
    }
}

export {
    EnergyVectorClass,
    EnergyVectorCollection,
    EnergyVectorStoreCollection,
};
